import { render, staticRenderFns } from "./DiagnosticInfoItem.vue?vue&type=template&id=4153f154&"
import script from "./DiagnosticInfoItem.vue?vue&type=script&lang=js&"
export * from "./DiagnosticInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports